import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import { pushNotification } from "utils/notifications";
import { getListHopDongDelete } from "actions/DanhSachHopDongDelete";
import DanhSachHopDongDeleteApi from "service/danhSachHopDongDeleteApi";

export const KhoiPhuc = ({ show, onHide, Id, Code }) => {
  const dataSearch = useSelector((state) => state.dataSearchHopDongDelete);
  const dispatch = useDispatch();
  const [dangXuLy, setDangXuLy] = useState(false);

  const khoiPhucHopDong = () => {
    if (dangXuLy) return;
    setDangXuLy(true);
    const baoLoi = (message) => {
      setDangXuLy(false);
      pushNotification(message || "Khôi phục không thành công", "error", "TOP_CENTER", 3000);
    };
    DanhSachHopDongDeleteApi.khoiPhucHopDongDelete(Id)
      .then((response) => {
        const { Error, Message } = response.data || {};
        if (Error !== 0) return baoLoi(Message);
        // onHide gỡ modal khỏi cây nên không set state sau đó
        onHide();
        dispatch(getListHopDongDelete(dataSearch));
        pushNotification(Message, "success", "TOP_CENTER", 1500);
      })
      .catch(() => baoLoi());
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="modal-dialog modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title">
          <span className="btn-icon-right">
            <i className="mdi mdi-restore"></i>
          </span>
          Xác nhận khôi phục
        </h4>
        <button type="button" className="close-popup-new" onClick={onHide}>
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="form-group row">
              <label className="col-md-12 label-control text-left">
                Bạn có chắc chắn muốn khôi phục hợp đồng {Code} không? Hợp đồng
                sẽ trở về trạng thái đang vay, lịch kỳ lãi được rải lại và các
                phiếu thu chi lúc tạo hợp đồng được ghi nhận lại vào quỹ.
              </label>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-new-main btn-checknew"
          onClick={khoiPhucHopDong}
          disabled={dangXuLy}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-check"></i>
          </span>
          {dangXuLy ? "Đang xử lý..." : "Xác nhận"}
        </button>
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
